import { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";

import LinearLoaderWithTime from "../../../Loaders/LinearLoaderWithTime";
import { AdleLogoLoader } from "../../../../assets/svg/AdleLogoLoader";
import { IS_ADLE_DOMAIN } from "../../../../utils/constants";
import {
  COMPETITORS_LOADER_COMPLETE_STEP,
  COMPETITORS_LOADER_EASE_EXPONENT,
  COMPETITORS_LOADER_FINISH_DELAY_MS,
  COMPETITORS_LOADER_MAX_PROGRESS_UNTIL_READY,
  COMPETITORS_LOADER_TICK_MS,
} from "../constants";

const CompetitorsInitialLoader = ({
  durationMs,
  isContentReady = false,
  onComplete = () => {},
  labels = [],
  labelSide = "top",
  totalTopOffsetPx = 0,
}) => {
  const [progress, setProgress] = useState(0);
  const startTimeRef = useRef(Date.now());
  const hasCompletedRef = useRef(false);

  useEffect(() => {
    startTimeRef.current = Date.now();
    hasCompletedRef.current = false;
    setProgress(0);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) => {
        if (hasCompletedRef.current) {
          return prevProgress;
        }

        if (isContentReady) {
          const nextProgress = Math.min(
            prevProgress + COMPETITORS_LOADER_COMPLETE_STEP,
            100
          );

          if (nextProgress >= 100) {
            hasCompletedRef.current = true;
            setTimeout(onComplete, COMPETITORS_LOADER_FINISH_DELAY_MS);
          }

          return nextProgress;
        }

        const elapsed = Date.now() - startTimeRef.current;
        const ratio = Math.min(elapsed / durationMs, 1);
        const easedProgress =
          (1 - (1 - ratio) ** COMPETITORS_LOADER_EASE_EXPONENT) *
          COMPETITORS_LOADER_MAX_PROGRESS_UNTIL_READY;

        return Math.max(prevProgress, easedProgress);
      });
    }, COMPETITORS_LOADER_TICK_MS);

    return () => {
      clearInterval(timer);
    };
  }, [durationMs, isContentReady, onComplete]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        px: 4,
        py: 6,
        minHeight: `calc(100vh - ${totalTopOffsetPx + 120}px)`,
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 640,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1,
        }}
      >
        {IS_ADLE_DOMAIN ? (
          <Box sx={{ maxHeight: 48, lineHeight: 0 }}>
            <AdleLogoLoader width="80px" />
          </Box>
        ) : null}
        <LinearLoaderWithTime
          labelSide={labelSide}
          labels={labels}
          progress={progress}
          sx={{ width: "100%" }}
        />
      </Box>
    </Box>
  );
};

export default CompetitorsInitialLoader;
